<template>
  <!-- <div class="modal-tom extra-z col-xl-1 col-1" v-if="showPersonalInfoHelpModal">
    <div class="modal-content d-flex flex-column align-items-center w-25 p-5">
      <div class="d-flex align-items-center w-100 justify-content-evenly">
        <div></div>
        <h3 class="fs-3">Personal Identifying Information</h3>
        <button class="btn btn-xl btn-primary" @click="showPersonalInfoHelpModal = false"><i class="fa fa-close"></i></button>
      </div>
      <p class="fs-5 pt-5">
        By default, CrimeTime allows its users to enter in information related to their cases so that users can easily distinguish between different cases, and in some cases, this can be Personally Identifying Information for those involved in the case.
      </p>
      <p class="fs-5 pt-5">
        For some users, entering this information may be against their company policy, or may be seen as a potential security risk, and for these reasons, we allow organization administrators and owners to disable this feature for their users.
      </p>
      <p class="fs-5 pt-5">If you have any questions or need support, please contact us at <a href="mailto:support@placergroup.com" style="color: blue; text-decoration: underline;">support@placergroup.com</a>.</p>
    </div>
  </div> -->

  <div class="mb-1 fs-5 col-12 col-xl-6 p-0 main">
    <!-- <div class="card-header fs-6 fw-bold pt-2 pb-2 pl-3">
      <div class="row">
        <div class="text-align-center">Create New Case</div>
        
      </div>
    </div> -->
    <div class="d-flex justify-content-center p-3">
      <!-- <div class=" fs-5 fw-bold pb-4 text-dark" >
        Defendant:
      </div> -->
      <!-- {{ this.newCase?.DefendantBirthdate }}
      {{ this.newCase?.DefendantLastName }}
      {{ this.newCase?.DefendantFirstName }}  -->
      <div class="col-12 p-0">
        <!-- Private User Section  -->
        <div v-if="newCaseFlag == true && showInfo" class="card mb-5">
          <div class="card-header d-flex ">
            <span class="fs-5 fw-bold p-0"> Personal Identifying Information </span>
          </div>
          <div class="d-flex card-body fs-5 py-2">
            <!-- CrimeTime allows users to enter information related to their cases, which may include personally identifying details. -->
            Your agency's administrator(s) may have disabled personal identifying
            information for security reasons.
          </div>
          <!-- <i :class="showInfo ? 'fa fa-caret-up' : 'fa fa-caret-down'" @click="showInfo = !showInfo" style="cursor: pointer;"></i> -->
        </div>

        <!-- County User Section -->
        <div
          v-if="
            organizationSettings &&
            Object.keys(organizationSettings).length > 0 &&
            organizationSettings?.DefendantFirstName
          "
          class="p-0"
        >
          <label class="fs-5 fw-bold">First Name</label>
          <span
            class="fs-6 error"
            v-if="showErrors && newCase.DefendantFirstName?.length == 0"
            >Required</span
          >
          <input
            type="text"
            class="form-control form-control-lg fs-5 w-100 mb-3 m-0"
            :placeholder="
              organizationSettings?.DefendantFirstName === false ? 'John' : 'First Name'
            "
            v-model="newCase.DefendantFirstName"
            ref="firstname"
            :disabled="organizationSettings?.DefendantFirstName === false"
          />
        </div>
        <div
          v-else-if="
            !organizationSettings || Object.keys(organizationSettings).length === 0
          "
          class="p-0"
        >
          <label class="fs-5 fw-bold">First Name</label>
         
          <span
            class="fs-6 error"
            v-if="showErrors && newCase.DefendantFirstName?.length == 0"
            >Required</span
          >
          <input
            type="text"
            class="form-control form-control-lg fs-5 w-100 mb-3 m-0"
            :placeholder="
              organizationSettings?.DefendantFirstName === false ? 'John' : 'First Name'
            "
            v-model="newCase.DefendantFirstName"
            ref="firstname"
            :disabled="organizationSettings?.DefendantFirstName === false"
          />
        </div>

        <!-- Middle name  -->
        <div
          v-if="
            organizationSettings &&
            Object.keys(organizationSettings).length > 0 &&
            organizationSettings?.DefendantMiddleName
          "
          class="p-0"
        >
          <label class="fs-5 fw-bold">Middle Name </label>
          <input
            type="text"
            class="form-control form-control-lg fs-5 w-100 mb-3 m-0"
            :placeholder="
              organizationSettings?.DefendantMiddleName === false ? 'M.' : 'Middle Name'
            "
            v-model="newCase.DefendantMiddleName"
            :disabled="organizationSettings?.DefendantMiddleName === false"
          />
        </div>
        <div
          v-else-if="
            !organizationSettings || Object.keys(organizationSettings).length === 0
          "
          class="p-0"
        >
          <label class="fs-5 fw-bold">Middle Name </label>
          <input
            type="text"
            class="form-control form-control-lg fs-5 w-100 mb-3 m-0"
            :placeholder="
              organizationSettings?.DefendantMiddleName === false ? 'M.' : 'Middle Name'
            "
            v-model="newCase.DefendantMiddleName"
            :disabled="organizationSettings?.DefendantMiddleName === false"
          />
        </div>

        <!-- Last name  -->
        <div
          v-if="
            organizationSettings &&
            Object.keys(organizationSettings).length > 0 &&
            organizationSettings?.DefendantLastName
          "
          class="p-0"
        >
          <label class="fs-5 fw-bold">Last Name</label>
          <span
            class="fs-6 error"
            v-if="showErrors && newCase.DefendantLastName?.length == 0"
            >Required</span
          >
          <input
            type="text"
            class="form-control form-control-lg fs-5 w-100 mb-3 m-0"
            :placeholder="
              organizationSettings?.DefendantLastName === false ? 'Doe' : 'Last Name'
            "
            v-model="newCase.DefendantLastName"
            :disabled="organizationSettings?.DefendantLastName === false"
          />
        </div>
        <div
          v-else-if="
            !organizationSettings || Object.keys(organizationSettings).length === 0
          "
          class="p-0"
        >
          <label class="fs-5 fw-bold">Last Name</label>
          <span
            class="fs-6 error"
            v-if="showErrors && newCase.DefendantLastName?.length == 0"
            >Required</span
          >
          <input
            type="text"
            class="form-control form-control-lg fs-5 w-100 mb-3 m-0"
            :placeholder="
              organizationSettings?.DefendantLastName === false ? 'Doe' : 'Last Name'
            "
            v-model="newCase.DefendantLastName"
            :disabled="organizationSettings?.DefendantLastName === false"
          />
        </div>

        <!-- DOB -->
        <div
          v-if="
            organizationSettings &&
            Object.keys(organizationSettings).length > 0 &&
            organizationSettings?.DefendantDOB
          "
        class="p-0"
        >
          <label class="fs-5 fw-bold"
            >Date of Birth
            {{
              newCase?.DefendantBirthdate
                ? new Date(newCase?.DefendantBirthdate).toLocaleDateString()
                : new Date("01/01/2000").toLocaleDateString()
            }}
            <br />
            <span style="font-weight: 300">
              {{ currentAge }}
            </span>
          </label>

          <div class="d-flex justify-content-between mb-3">
            <div class="d-flex flex-column pl-0">
              <label class="m-0 fw-bold">Month</label>
              <select
                v-model="dobm"
                class="form-control form-control-lg fs-5"
                :disabled="organizationSettings?.DefendantDOB === false"
              >
                <option :value="n" :key="n" v-for="n in 12">
                  <!-- {{ n < 10 ? `0${n}` : n }} -->
                  {{ ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'][n - 1] }}
                </option>
              </select>
            </div>
            <div class="d-flex flex-column px-3">
              <label class="m-0 fw-bold">Day</label>
              <select
                v-model="dobd"
                class="form-control form-control-lg fs-5"
                :disabled="organizationSettings?.DefendantDOB === false"
              >
                <option :value="n" :key="n" v-for="n in 31">
                  <!-- {{ n < 10 ? `0${n}` : n }} -->
                  {{ n }}
                </option>
              </select>
            </div>
            <div class="d-flex flex-column p-0">
              <label class="m-0 fw-bold">Year</label>
              <select
                v-model="doby"
                class="form-control form-control-lg fs-5"
                :disabled="organizationSettings?.DefendantDOB === false"
              >
                <option :value="2023 - n" :key="2023 - n" v-for="n in 123">
                  {{ 2023 - n }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div v-else-if="!showInfo" class="p-0">
          <label class="fs-5 fw-bold"
            >Date of Birth
            {{
              newCase?.DefendantBirthdate
                ? new Date(newCase?.DefendantBirthdate).toLocaleDateString()
                : new Date("01/01/2000").toLocaleDateString()
            }}
            <br />
            <span style="font-weight: 300">
              {{ currentAge }}
            </span>
          </label>

          <div class="d-flex justify-content-between mb-3 mt-3">
            <div style="min-width: 50px" class="d-flex flex-column pl-0 col-3">
              <label class="m-0 fw-bold">MM</label>
              <select
                v-model="dobm"
                class="form-control form-control-lg fs-5"
                :disabled="organizationSettings?.DefendantDOB === false"
              >
                <option :value="n" :key="n" v-for="n in 12">
                  <!-- {{ n < 10 ? `0${n}` : n }} -->
                  {{ n }}
                </option>
              </select>
            </div>
            <div style="min-width: 50px" class="d-flex flex-column pl-0 col-3">
              <label class="m-0 fw-bold">DD</label>
              <select
                v-model="dobd"
                class="form-control form-control-lg fs-5"
                :disabled="organizationSettings?.DefendantDOB === false"
              >
                <option :value="n" :key="n" v-for="n in 31">
                  <!-- {{ n < 10 ? `0${n}` : n }} -->
                  {{ n }}
                </option>
              </select>
            </div>
            <div style="min-width: 50px" class="d-flex flex-column p-0 col-6">
              <label class="m-0 fw-bold">YYYY</label>
              <select
                v-model="doby"
                class="form-control form-control-lg fs-5"
                :disabled="organizationSettings?.DefendantDOB === false"
              >
                <option :value="2023 - n" :key="2023 - n" v-for="n in 123">
                  {{ 2023 - n }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <!-- Case Number & Case Status -->
        <div class="d-flex p-0 flex-wrap w-100">
          <!-- Case Number Field (appears regardless of newCaseFlag value) -->
          <div
            class="p-0 pr-3 d-flex flex-column"
            v-if="
              organizationSettings &&
              Object.keys(organizationSettings).length > 0 &&
              organizationSettings?.ReferenceNumber
            "
            :class="newCaseFlag == true ? 'col-12' : 'col-6'"
          >
            <label class="fs-5 fw-bold">Case Number</label>
            <input
              type="text"
              class="form-control-lg  fs-5  mb-0 m-0"
              :placeholder="'Optional'"
              v-model="newCase.CaseNumber"
              :disabled="organizationSettings?.AutoGenerateReferenceNumber"
            />
            <!-- <span v-if="newCaseFlag == true" class="pt-0 mt-0 pl-3" style="font-size: 12px">If left blank, a unique case number will be generated</span> -->
          </div>

          <div
            v-else-if="
              !organizationSettings || Object.keys(organizationSettings).length === 0
            "
            :class="newCaseFlag == true ? 'col-12' : 'col-6'"
            class="pl-0 "
          >
            <label class="fs-5 fw-bold">Case Number</label>
            <input
              type="text"
              class="form-control form-control-lg fs-5 w-100 m-0"
              :placeholder="'Optional'"
              v-model="newCase.CaseNumber"
            />
            <span
              v-if="newCaseFlag == true"
              class="pt-0 mt-0 pl-3"
              style="font-size: 12px"
              >If left blank, a unique case number will be generated</span
            >
          </div>

          <!-- Case Status Field -->
          <div
            class="p-0 mb-5"
            :class="newCaseFlag ? 'col-12' : 'col-6'"
            v-if="!newCaseFlag"
            
          >
            <label class="fw-bold">Case Status</label>
            <div class="w-100">
              <select class="form-control-lg fs-5 w-100" v-model="newCase.CaseStatus">
                <option value="0">Open</option>
                <option value="1">Closed</option>
                <option value="2">Bench Warrant</option>
              </select>
            </div>
          </div>
        </div>

        <div v-if="checkOrgSettings && newCaseFlag == true" class="pr-0 mx-auto">
          <label class="fs-5">Clicking 'Ok' will create a blank case with an auto generated case #</label>
        </div>

        <div class="d-flex justify-content-center w-100 mt-3">

          <button
            v-if="newCaseFlag == true"
            class="btn btn-primary btn-xl bordered"
            @click="saveNewCase"
          >
            {{
              organizationSettings &&
              organizationSettings?.ReferenceNumber === false &&
              organizationSettings?.DefendantDOB === false &&
              organizationSettings?.DefendantLastName === false &&
              organizationSettings?.DefendantMiddleName === false &&
              organizationSettings?.DefendantFirstName === false
                ? "OK"
                : "Create"
            }}
          </button>
          <button
            v-if="newCaseFlag == false"
            class="btn btn-primary btn-xl"
            @click="updateCase"
          >
            Save Changes
          </button>
        </div>

        <!-- <div class="" v-if="newCaseFlag == false">
         
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import fetch from "node-fetch";
import moment from "moment";
import { handleError } from "../../helpers";
import { useCaseStore } from "../../stores/CaseStore"
// import DatePick from "vue-date-pick";
export default {
  // components: { DatePick },
  name: "NewCase",
  props: ["app_token", "newCaseFlag", "currentCase", "organizationSettings", "rowCount"],
  data() {
    return {
      newCase: {
        DefendantFirstName: "",
        DefendantLastName: "",
        DefendantMiddleName: "",
        DefendantBirthdate: null,
        DefendantIs1170Ineligible: "",
        HasSuperStrike: "",
        CaseNumber: "",
        ComplaintDate: "",
        CaseStatus: 0,
        SurrenderDate: "",
        organizationSettings: {},
        OwnerId: JSON.parse(localStorage.getItem("user_attr"))?.id,
        Id: 0,
        caseAttributes: {
          tomsStupidRule: false,
          runStirCalculation: true,
          ProbationSelections: [],
        },
      },
      dt: moment,
      dobm: 1,
      dobd: 1,
      doby: 2000,
      showErrors: false,
      noOrgSettings: false,
      caseStore: useCaseStore(),
      //modals
      showPersonalInfoHelpModal: false,
      // showInfo: false,
    };
  },
  computed: {
    computedCaseNumberPlaceholder() {
      // Only show the autogenerated reference as a placeholder if CaseNumber is empty
      return !this.newCase.CaseNumber ? this.autoGeneratedReference : "(Optional)";
    },

    computedCaseNumber: {
      get() {
        // Check if all required fields are empty
        const allFieldsEmpty =
          (!this.newCase.DefendantFirstName ||
            this.newCase.DefendantFirstName.length === 0) &&
          (!this.newCase.DefendantMiddleName ||
            this.newCase.DefendantMiddleName.length === 0) &&
          (!this.newCase.DefendantLastName ||
            this.newCase.DefendantLastName.length === 0) &&
          (!this.newCase.DefendantBirthdate ||
            this.newCase.DefendantBirthdate.length === 0);

        // Only use autoGeneratedReference if CaseNumber is empty and all fields are empty
        return allFieldsEmpty && !this.newCase.CaseNumber
          ? this.autoGeneratedReference
          : this.newCase.CaseNumber;
      },
      set(value) {
        // Update newCase.CaseNumber with user input
        this.newCase.CaseNumber = value;
      },
    },

    showInfo() {
      if (
        this.organizationSettings &&
        (this.organizationSettings.DefendantDOB == false ||
          this.organizationSettings.DefendantLastName == false ||
          this.organizationSettings.DefendantMiddleName == false ||
          this.organizationSettings.ReferenceNumber == false ||
          this.organizationSettings.DefendantFirstName == false)
      ) {
        return true;
      }
    },
    // Returns true if all organization settings fields are false for county users, false for private users
    checkOrgSettings() {
      if (
        !this.organizationSettings ||
        Object.keys(this.organizationSettings).length === 0
      ) {
        this.noOrgSettings = false;
        return false;
      }

      const ReferenceNumber = this.organizationSettings.ReferenceNumber;
      const DefendantDOB = this.organizationSettings.DefendantDOB;
      const DefendantLastName = this.organizationSettings.DefendantLastName;
      const DefendantMiddleName = this.organizationSettings.DefendantMiddleName;
      const DefendantFirstName = this.organizationSettings.DefendantFirstName;

      this.noOrgSettings =
        !ReferenceNumber &&
        !DefendantDOB &&
        !DefendantLastName &&
        !DefendantMiddleName &&
        !DefendantFirstName;
      return this.noOrgSettings;
    },

    currentAge() {
      if (!this.newCase?.DefendantBirthdate) return "";
      return `Current Age: ${this.dt(Date.now()).diff(
        this.dt(this.newCase.DefendantBirthdate),
        "years"
      )}y ${
        this.dt(this.futureReleaseDate).diff(
          this.dt(this.newCase?.DefendantBirthdate),
          "months"
        ) % 12
      }m`;
    },
    autoGeneratedReference() {
      // Get the last two digits of the current year
      const currentYear = new Date().getFullYear().toString().slice(-2);

      // Generate the incrementing number based on rowCount
      const incrementingNumber = (this.rowCount + 1).toString().padStart(2, "0");

      // "YY-00-XX" where YY is the last two digits of the current year
      return `${currentYear}-00-${incrementingNumber}`;
    },
  },

  methods: {
    closeNewCaseWindow(e) {
      if (this.newCaseFlag == true) {
        e.preventDefault();
        // console.log("close this form now!");
        this.$emit("closeNewCaseEvent", "formClosed");
      } else {
        e.preventDefault();
        // console.log("close this edit form now!");
        this.$emit("closeEditCase", this.newCase);
      }
    },

    // fetchUpdatedCase() {
    //   axios
    //     .get(process.env.VUE_APP_ENDPOINT + "/api/cases/" + this.currentCase.Id, {
    //       headers: {
    //         Authorization: "Bearer " + this.app_token,
    //       },
    //     })
    //     .then((response) => {
    //       console.log("Fetched updated case data:", response.data);
    //       this.newCase = { ...response.data };  // Spread to create a new object
    //       console.log("Updated case data:", this.newCase);
    //     })
    //     .catch((error) => {
    //       console.error("Error fetching updated case data:", error);
    //     });
    // },

    updateCase(e) {
      e.preventDefault();
      let token = this.app_token;

      const body = {}
      
      body.DefendantFirstName = this.newCase.DefendantFirstName;
      body.DefendantLastName = this.newCase.DefendantLastName;
      body.DefendantMiddleName = this.newCase.DefendantMiddleName;
      body.CaseNumber = this.newCase.CaseNumber;
      body.CaseStatus = this.newCase.CaseStatus;
      body.DefendantBirthdate = this.newCase.DefendantBirthdate;
      body.Id = this.newCase.Id;
      
      // delete body.DefendantIs1170Ineligible
      // delete body.HasSuperStrike
      // delete body.ComplaintDate
      // delete body.SurrenderDate
      // delete body.organizationSettings
      // delete body.OwnerId

      axios
        .put(process.env.VUE_APP_ENDPOINT + "/api/cases/" + this.newCase.Id, body, {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        })
        .then((res) => {
          if (res.status === 200 || res.status === 201) {
            // Emit the saved event
            this.$emit("savedNewCaseEvent", "formClosed", false);

            // // Fetch the updated data to reflect changes immediately
            // this.fetchUpdatedCase();
          }
        })
        .catch(handleError);
      this.currentCase.DefendantFirstName = this.newCase.DefendantFirstName;
      this.currentCase.DefendantLastName = this.newCase.DefendantLastName;
      this.currentCase.DefendantMiddleName = this.newCase.DefendantMiddleName;
      this.currentCase.DefendantBirthdate = this.newCase.DefendantBirthdate;
      this.currentCase.CaseNumber = this.newCase.CaseNumber;
      this.currentCase.CaseStatus = this.newCase.CaseStatus;
      this.caseStore.loadCases(true)
      this.closeNewCaseWindow(e);
    },

    //this handles users with and without organization settings
  saveNewCase(e) {
    e.preventDefault();
    const token = this.app_token;
    let isValid = true;
    this.showErrors = false;

    
    const isEmptyOrgSettings = !this.organizationSettings || Object.keys(this.organizationSettings).length === 0;

    if (
      (isEmptyOrgSettings || this.organizationSettings?.DefendantFirstName === true) &&
      !this.newCase?.DefendantFirstName?.length
    ) {
      this.showErrors = true;
      isValid = false;
    }

    if (
      (isEmptyOrgSettings || this.organizationSettings?.DefendantLastName === true) &&
      !this.newCase?.DefendantLastName?.length
    ) {
      this.showErrors = true;
      isValid = false;
    }

    if ((isEmptyOrgSettings || this.organizationSettings?.DefendantDOB === true)) {
      this.newCase.DefendantBirthdate = new Date(this.doby, this.dobm - 1, this.dobd);
      if (!this.newCase?.DefendantBirthdate) {
        this.showErrors = true;
        isValid = false;
      }
    }

    const allFieldsEmpty =
      (!this.newCase.DefendantFirstName || this.newCase.DefendantFirstName.length === 0) &&
      (!this.newCase.DefendantMiddleName || this.newCase.DefendantMiddleName.length === 0) &&
      (!this.newCase.DefendantLastName || this.newCase.DefendantLastName.length === 0) &&
      (!this.newCase.DefendantBirthdate || this.newCase.DefendantBirthdate.length === 0);

    // Use the auto-generated reference only if CaseNumber is empty and all other fields are empty
    if (!this.newCase.CaseNumber && allFieldsEmpty) {
      this.newCase.CaseNumber = this.autoGeneratedReference;
    }

    if (isValid) {
      this.newCase.Created = moment().format('YYYY-MM-DD HH:mm:ss');
      axios
        .post(`${process.env.VUE_APP_ENDPOINT}/api/cases`, this.newCase, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          if (res.status === 200 || res.status === 201) {
            window.location.href = `/Cases/${res.data.Id}`;
          }
        })
        .catch(handleError);
    } else {
      console.error("Validation failed. Please fill out the required fields.");
    }
  },



    fixDate() {
      this.newCase.DefendantBirthdate = new Date(this.doby, this.dobm - 1, this.dobd);
      this.showErrors = false;
    },
  },
  watch: {
    dobd: "fixDate",
    dobm: "fixDate",
    doby: "fixDate",
    newCase: "fixDate",
  },

  async mounted() {
    // this.$nextTick(() => this.$refs.firstname.focus()); // just watch out with going too fast !!!

    const token = localStorage.getItem("user_token");
    const user = await axios
      .post(
        process.env.VUE_APP_ENDPOINT + "/api/auth/checkcredentials",
        { user_token: token },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ` + token,
          },
        }
      )
      .then((data) => {
        return data.data.user_attr;
      }).catch(e => handleError(e));
    if (this.newCaseFlag == false) {
      // console.log("this.currentCase:", this.currentCase);
      // load case data

      // console.log(this.currentCase)
      this.newCase.DefendantFirstName = this.currentCase.DefendantFirstName;
      this.newCase.DefendantLastName = this.currentCase.DefendantLastName;
      this.newCase.DefendantMiddleName = this.currentCase.DefendantMiddleName;
      this.newCase.DefendantBirthdate = this.currentCase.DefendantBirthdate;
      this.newCase.CaseNumber = this.currentCase.CaseNumber;
      this.newCase.CaseStatus = this.currentCase.CaseStatus;
      // console.log(this.newCase.CaseStatus);
      // console.log(this.currentCase.CaseStatus);
      this.newCase.OwnerId = user.id;
      this.newCase.Id = this.currentCase.Id;
      this.dobm = new Date(this.currentCase?.DefendantBirthdate).getMonth() + 1;
      this.dobd = new Date(this.currentCase?.DefendantBirthdate).getDate();
      this.doby = new Date(this.currentCase?.DefendantBirthdate).getFullYear();
      this.fixDate();
      // console.log(this.currentCase?.DefendantBirthdate);
      // console.log(this.dobm, this.dobd, this.doby);
    }
    // console.log(this.newCase.organizationSettings)
    
  },
};
</script>
<style scoped>
.extra-z {
  z-index: 1000;
}

.box {
  border: 1px solid #000;
  /* Black border for consistency */
  border-radius: 8px;
  /* Smooth corners */
  padding: 20px;
  /* Adjust padding for inner content spacing */
  background-color: #f8f9fa;
  /* Optional: light background for separation */
  margin-bottom: 20px;
  /* Adds space between this section and the next */
}

input:disabled {
  background-color: #e9ecef;
  /* Light gray background */
  color: #6c757d;
  /* Gray text color */
  cursor: not-allowed;
  /* Change the cursor to indicate it's not clickable */
  opacity: 0.65;
  /* Slightly reduce opacity */
}

select:disabled {
  background-color: #e9ecef;
  /* Light gray background */
  color: #6c757d;
  /* Gray text color */
  cursor: not-allowed;
  /* Change the cursor to indicate it's not clickable */
  opacity: 0.65;
  /* Slightly reduce opacity */
}

.error {
  font-size: 8px;
  color: red;
  margin-left: 20px;
}

.main {
  min-width: 20vw;
}
</style>
